import { render, staticRenderFns } from "./CusChatSupervise.vue?vue&type=template&id=030fae54&scoped=true&"
import script from "./CusChatSupervise.vue?vue&type=script&lang=js&"
export * from "./CusChatSupervise.vue?vue&type=script&lang=js&"
import style0 from "./CusChatSupervise.vue?vue&type=style&index=0&id=030fae54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030fae54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/01-qym-hop-newmall-frontend-k8s@3/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('030fae54')) {
      api.createRecord('030fae54', component.options)
    } else {
      api.reload('030fae54', component.options)
    }
    module.hot.accept("./CusChatSupervise.vue?vue&type=template&id=030fae54&scoped=true&", function () {
      api.rerender('030fae54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chat/CusChatSupervise.vue"
export default component.exports